import * as React from "react";

export interface IEventCustomAttributeProps {
    name: string;
    value: string;
    dataType: string;
};

export const CustomAttributeRow = (props: IEventCustomAttributeProps) => {
    const name = props.name;
    let value = props.value;
    const isRichText = props.dataType === "richtext";
    const isDateOnlyType = props.dataType === "date";

    if (isDateOnlyType && value === "1800-01-01") { value = ""; }

    return (
        <li className="CAL-EVENT-cRow">
            <div className="CAL-EVENT-cR-title">{name}</div>
            {!isRichText &&
                <div className="CAL-EVENT-cR-content">{value}</div>
            }
            {isRichText &&
                <div className="CAL-EVENT-cR-content" dangerouslySetInnerHTML={{ __html: `${value}` }}>
                    {/* Have to use dangerouslySetHTML to force React to render raw HTML. */}
                </div>
            }
        </li>
    );
};
